import { render, staticRenderFns } from "./insertCode.vue?vue&type=template&id=016a2692"
import script from "./insertCode.vue?vue&type=script&lang=js"
export * from "./insertCode.vue?vue&type=script&lang=js"
import style0 from "./insertCode.vue?vue&type=style&index=0&id=016a2692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.109.2_postcss@8_3af7dec0bf3d0a51e27ccc55ef35200c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports